import { useQuery } from '@tanstack/react-query';
import apiClient from '../../lib/api';

/**
 * 通信の秘密同意 status クエリの共有キー。
 *
 * 3 箇所（本フック / CommunicationConsentGate の楽観更新 / LinkToken の
 * 事前フェッチ / ConsentPage の保存後楽観更新）で同一キーを参照する必要があるため
 * リテラル重複を避け、`as const` で readonly tuple として export する
 * （PR-3 レビュー nit 指摘）。
 */
export const communicationSecretConsentStatusKey = [
  'communicationSecretConsent',
  'status',
] as const;

/**
 * 通信の秘密同意の取得状況を取得するカスタムフック。
 * CommunicationConsentGate から利用され、has_current === false なら /consent へ強制遷移する。
 *
 * 設計書: docs/pre-design/communication-secret-consent/design.md §8.2
 */
export const useCommunicationSecretConsentStatus = (enabled: boolean = true) => {
  return useQuery({
    queryKey: communicationSecretConsentStatusKey,
    queryFn: async () => {
      return await apiClient.getCommunicationSecretConsentStatus();
    },
    enabled: enabled && !!apiClient.getIdToken(),
    staleTime: 60 * 1000, // 1 分間キャッシュ（Gate が頻繁に走らないよう緩めに）
    retry: 1,
  });
};

export default useCommunicationSecretConsentStatus;
